import API from '../api/api';
import { ApiRoutes } from '../constans/api';
export interface ITopicbaseTopicItem {
  code: string;
  order: number;
  text: object;
  estimatedResponseTime: number;
}

export interface ITopicbaseTopic {
  code: string;
  order: number;
  title: object;
  shortDescription: object;
  numberOfItems: number;
  items: ITopicbaseTopicItem[];
}

export interface ITopicbaseCategory {
  code: string;
  order: number;
  title: object;
  description: object;
  numberOfTopics: number;
  numberOfItems: number;
  topics: ITopicbaseTopic[];
}

export interface ITopicbaseOpenQuestion {
  code: string;
  order: number;
  text: Record<string, string>;
}

export interface IGetTopicbaseRequest {
  surveyType: string;
  categories: ITopicbaseCategory[];
  openQuestions: ITopicbaseOpenQuestion[];
}

export const getTopicbaseRequest = async (
  surveyType: string,
  customLang?: string
): Promise<IGetTopicbaseRequest> => {
  const { topicbase } = ApiRoutes;
  const lang = customLang || 'en';
  const { data } = await API.get(`${topicbase}${surveyType}/?ln=${lang}`);
  return data;
};
